// extracted by mini-css-extract-plugin
module.exports = {"nav":"HeaderNav_nav_1lLfw","logo":"HeaderNav_logo_223c_","menu":"HeaderNav_menu_2DpZS","install":"HeaderNav_install_2SKZ4","prompt":"HeaderNav_prompt_1BlDw"};